import { render, staticRenderFns } from "./SelectSupplier.vue?vue&type=template&id=53112f20&scoped=true"
import script from "./SelectSupplier.vue?vue&type=script&lang=js"
export * from "./SelectSupplier.vue?vue&type=script&lang=js"
import style0 from "./SelectSupplier.vue?vue&type=style&index=0&id=53112f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53112f20",
  null
  
)

export default component.exports